export class SellerPurchaseConfig {
  static readonly type = '[Seller] PurchaseConfig';
  constructor(public cardProgrammeCd: string) {}
}

export class SellerSalesPerson {
  static readonly type = '[Seller] SellerSalesPerson';
  constructor() {}
}

export class UpdateSellers {
  static readonly type = '[Seller] UpdateSellers';
  constructor() {}
}

export class SelectedSellerStore {
  static readonly type = '[Seller] SelectedSellerStore';
  constructor(
    public storeId: number,
    public storeName: string,
    public dealerNumber: number,
    public sellerGroupId: number
  ) {}
}

export class AddSelectedSeller {
  static readonly type = '[Seller] AddSelectedSeller';
  constructor(
    public storeId: number,
    public storeName: string,
    public dealerNumber: number,
    public sellerGroupId: number
  ) {}
}
